export const unitsOfMeasure = [
  { text: 'Acres', value: 'Acres' },
  { text: 'Cubic Feet', value: 'CuFt' },
  { text: 'Cubic Inches', value: 'CuIn' },
  { text: 'Cubic Meters', value: 'CuM' },
  { text: 'Cubic Yards', value: 'CuYd' },
  { text: 'Feet', value: 'Ft' },
  { text: 'Gallons', value: 'Gal' },
  { text: 'Hectares', value: 'Hectares' },
  { text: 'Inches', value: 'In' },
  { text: 'Liters', value: 'L' },
  { text: 'Meters', value: 'M' },
  { text: 'Milliliters', value: 'ML' },
  { text: 'Millimeter', value: 'mm' },
  { text: 'Square Feet', value: 'SqFt' },
  { text: 'Square Inches', value: 'SqIn' },
  { text: 'Square Kilometers', value: 'SqKm' },
  { text: 'Square Meters', value: 'SqM' },
  { text: 'Square Miles', value: 'SqMi' },
  { text: 'Square Yards', value: 'SqYd' },
  { text: 'Yards', value: 'Yd' },
];

export const linearUnits = ['M', 'Ft', 'In', 'Yd', 'mm','Gal', 'L', 'ML'];

export const volumetric = ['CuFt', 'CuM', 'CuYd', 'CuIn'];

export const areaUnits = ['SqFt', 'SqM', 'SqYd', 'SqKm', 'SqMi', 'SqIn', 'Acres', 'Hectares'];

export const uomCalculations = {
  "SqFt": (length, width) => length * width, // Square Feet
  "SqM": (length, width) => length * width, // Square Meters
  "Acres": (length, width) => (length * width) / 43560, // Acres
  "Hectares": (length, width) => (length * width) / 10000, // Hectares
  "LinearFeet": (length) => length, // Linear Feet
  "Millimeter": (length) => length, // Millimeter
  "SqYd": (length, width) => length * width, // Square Yards
  "SqIn": (length, width) => length * width, // Square Inches
  "CuFt": (length, width, height) => length * width * height, // Cubic Feet
  "CuM": (length, width, height) => length * width * height, // Cubic Meters
  "LinearMeters": (length) => length, // Linear Meters
  "SqKm": (length, width) => length * width, // Square Kilometers
  "SqMi": (length, width) => length * width, // Square Miles
  "CuYd": (length, width, height) => length * width * height, // Cubic Yards
  "CuIn": (length, width, height) => length * width * height, // Cubic Inches
  "gal": (length) => length, // Gallons
  "L": (length) => length, // Liters
  "mL": (length) => length, // Milliliters
};

export function calculateAreaOrVolume(uom, length, width, height = 0) {
  if (uomCalculations[uom]) {
    return uomCalculations[uom](length, width, height).toFixed(2);;
  } else {
    return 0;
  }
}
